module.exports = __webpack_public_path__ + "static/media/logo.f7575120.svg";